import React from 'react';
import { withStyles, Grid, Typography, ButtonBase, Divider } from '@material-ui/core';
import DeviceEventEmitter from '../../control/event';
import Swiper from 'react-id-swiper';
import ListView from 'antd-mobile/lib/list-view/index';
import PullToRefresh from 'antd-mobile/lib/pull-to-refresh';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';


import PreviewDoubleItem from '../view/PreviewDoubleItem';
import SlideBanner from './Slidebanner';
import MRedux from '../view/MRedux';
import { withRouter } from "react-router-dom"
import AppUtils from '../../control/apputlis';
import AppConfig from '../../control/config';
import Livelist from './Livelist';
import MSectionHeader from '../view/MSectionHeader';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import Live from '../../model/Live';

import IMEventEmitter from '../../net/IMEventEmitter';

import './home.css'
import ToName from '../../control/ToName';
const ICON_GIF = require("../../images/bg/ballLoad.gif");
const ICON1 = require("../../images/icons/ren_icon.png");


const PAGE_SIZE = 6


class HomeList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            carouselIndex: 0,
            offset: 0,
            isRefreshing: false,
            isRequirOffset: false,
            changeIndex: 0,
            topTtitle: '',
            h5Foot: null
        }
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 0,
            nums: 0,
        };

        this.container = null;


    }


    componentDidMount() {
        AppUtils.YMPush('MAIN', 'HomeList');
        // if (AppConfig.isiOS) {
        //     DeviceEventEmitter.on(EventName.HOME_REFRESH, this._onRefresh, this);
        // }

        this.getTopTitle()
        MRedux.recoverState('HOME_LIST_KEY_ALL', this.state);
        if (!this.state.data) {
            this.getTypeHostRecomm();
        } else {
            this.state.isRequirOffset = true;
            this.setState(this.state);
        }
        //登录完成的回调
        DeviceEventEmitter.on('LoginSuccess', this.isJumptoRoom, this);

    }

    //是否跳进直播间
    isJumptoRoom = async () => {
        console.log("收到登录完成");
        let match_type = AppUtils.getQueryVariable('match_type');
        let match_id = AppUtils.getQueryVariable('match_id');

        if (match_type && match_id) {
            let res = await Apis.encryptionJumpToRoom(match_type, match_id);
            console.log('=====>直播间', res);
            if (res.code == 200 && res.data && res.data != 0) {
                let data = {
                    room_id: res.data,
                    match_type, match_id
                }
                this._onClickAnchor(data)
            }


        }
    }

    getTopTitle = async () => {
        let res = await Apis.encryptionServerConfig();
        if (res.code == 200 && res.data) {
            this.setState({
                topTtitle: res.data.top_title,
                h5Foot: res.data.h5_foot_str
            })

            // //两秒之后
            // setTimeout(() => {


            // }, 1000 * 2)

            // let el = document.getElementById('contentdiv');
            // if (el) {
            //     document.getElementById('contentdiv').innerHTML = res.data.h5_foot_str;

            //     let imgs = document.getElementById("contentdiv").getElementsByTagName("img")
            //     for (let i = 0; i < imgs.length; i++) {
            //         const element = imgs[i];
            //         element.style.width = '100%'

            //     }
            // }
            // this.setState({})

        }

    }

    componentWillUnmount() {
        // if (AppConfig.isiOS) {
        //     DeviceEventEmitter.off(EventName.HOME_REFRESH, this._onRefresh, this);
        // }
        if (this.container && this.container.listviewRef.scrollProperties.offset !== 0) {
            this.state.offset = this.container.listviewRef.scrollProperties.offset;
        }
        DeviceEventEmitter.off('LoginSuccess', this.isJumptoRoom, this);
        MRedux.saveState('HOME_LIST_KEY_ALL', this.state);
        this.setState = () => false;
    }

    getHotNew = async (_list) => {
        let channel = AppConfig.channelid;
        Apis.getHomeListHotNew(channel).then((result) => {
            let newList = result.data.list.list;
            let hotList = result.data.hot_list

            let obj1 = { type: 4, list: hotList }
            let obj2 = { type: 5, list: newList }
            _list.splice(_list.length - 1, 0, obj1)
            _list.splice(_list.length - 1, 0, obj2)
            this.setState({ data: _list, isRefreshing: false });
        }).catch(() => {
            this.setState({ data: [], isRefreshing: false });
        });


    }

    getTypeHostRecomm = async () => {
        let _list = []; //这里整合数据，我要【[],[type=3]】，这样的格式
        if (!AppData.TypeHostRecomm || AppData.TypeHostRecomm.length == 0) {
            let result = await Apis.getTypeRecommend();



            _list.push({
                type: 0,
                list: result.data
            })

            if (result.code == 200) {
                let tempData = { recomm_title: '比赛集锦', list: [], type: 3 }
                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].list && result.data[i].list.length > 0) {
                        for (let j = 0; j < result.data[i].list.length; j++) {
                            if (result.data[i].list[j].live_type == Live.TYPE_CUSTOM) {
                                tempData.list.push(result.data[i].list[j]);
                                result.data[i].list.splice(j, 1);
                                j--;
                            }
                        }
                    }
                }
                // result.data.push(tempData);
                AppData.TypeHostRecomm = result.data;
                _list.push(tempData)
            }


        }
        this.getHotNew(_list)
    }

    _onClickMore = (data) => {


        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        ToName(this.props, `/morerecomm/${os}`, data)
        // this.props.history.push({ pathname: '/morerecomm/', data: data });
    }

    _onRefresh = (e) => {
        console.log('_onRefresh', this.state.isRefreshing);
        if (!this.state.isRefreshing) {
            AppData.recommAnchorData = [];
            AppData.TypeHostRecomm = [];
            this.setState({ isRefreshing: true });
            this.getTypeHostRecomm();
        }
    }

    _handelRef = (node) => {
        this.container = node;
        if (node && this.state.isRequirOffset) node.scrollTo(0, this.state.offset);
    }

    _onEndReached = () => {

    }
    _onClickAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;

        // this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        }
        let uid = AppUtils.getStorageItem('uid');
        let fastkey = AppUtils.getStorageItem("fastkey");
        let roomIp = AppUtils.getStorageItem("roomIp");
        let roomPort = AppUtils.getStorageItem("roomPort");

        let fid = AppData.me.free_id





        ToName(this.props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}`, data)
        // ToName(this.props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}`)

    }

    formatNum = (num) => {
        if (num > 100000000) {
            return (num / 100000000).toFixed(0) + '亿'
        } else if (num > 10000) {
            if (num > 1000000) {
                return (num / 10000).toFixed(0) + '万'
            } else if (num > 100000) {
                return (num / 10000).toFixed(1) + '万'
            }
        }
        return num;
    }

    //比赛集锦
    _renderType3 = (item, i) => {
        const { classes } = this.props;
        const topData = item[0];
        const bottomData = item[1];


        return (
            <Grid key={i} container alignItems='center' style={{ width: 110, marginLeft: 8 }}>
                {/* <LiveContent data={item} index={i} /> */}

                <Grid container direction='column' alignItems='center' className={classes.root}>
                    {topData &&
                        <ButtonBase disableRipple onClick={() => this._onClickAnchor(topData)} style={{ position: 'relative' }}>
                            <div className='ssItemBox'>
                                <img src={topData.room_cover} className='LazyLoadimg' />

                                <div className='room_title' >{topData.room_title}</div>
                            </div>
                            {
                                <Grid container direction='row' alignItems='center' justifyContent='center' className={classes.hotView} >
                                    <img src={ICON1} style={{ width: 5, height: 7, marginLeft: 4 }} />
                                    <Typography style={{ color: '#FFF', marginLeft: 4, fontSize: 9 }}>{this.formatNum(topData.heat)}</Typography>
                                </Grid>
                            }
                        </ButtonBase>
                    }

                    {bottomData &&
                        <ButtonBase disableRipple onClick={() => this._onClickAnchor(bottomData)} style={{ position: 'relative' }}>
                            <div className='ssItemBox' >

                                {/* <LazyLoad offset={200}> */}
                                <img src={bottomData.room_cover} className='LazyLoadimg' />
                                {/* </LazyLoad> */}
                                <div className='room_title'>{bottomData.room_title}</div>
                            </div>
                            {
                                <Grid container direction='row' alignItems='center' justifyContent='center' className={classes.hotView} >
                                    <img src={ICON1} style={{ width: 5, height: 7, marginLeft: 4 }} />
                                    <Typography style={{ color: '#FFF', marginLeft: 4, fontSize: 9 }}>{this.formatNum(bottomData.heat)}</Typography>
                                </Grid>
                            }
                        </ButtonBase>
                    }



                </Grid>
            </Grid>
        )
    }
    toDelite = (id) => {
        if (id == 0) {
            return;
        }
        let os = 0;
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        }

        // id/:os/:token/:customerId
        ToName(this.props, `/circleDel/${id}/${os}/${token}/${customerId}`)
    }

    //热门球圈
    _renderHotCircle = (rowData) => {

        const { classes } = this.props;
        let hotList = rowData.list

        return (
            <Grid >
                {/* 今日热门 */}
                {hotList.length > 3 &&

                    <Grid container className={classes.listItem} style={{ borderRadius: 10, marginTop: 10 }}>

                        {
                            rowData.list.length > 0 && this._renderCircleHeader('热门球圈', 1, 'Hot')
                        }


                        <div className='circleHotBox' style={{ margin: 0, paddingTop: 0 }}>
                            <div className='circleHotList'>
                                <div onClick={() => this.toDelite(hotList[0].bid)}>{hotList[0].title}</div>
                                <div onClick={() => this.toDelite(hotList[1].bid)} style={{ marginTop: 10 }}>{hotList[1].title}</div>
                            </div>
                            <div style={{ width: 1, height: 50, backgroundColor: '#E2E2E2' }}></div>
                            <div className='circleHotList'>
                                <div onClick={() => this.toDelite(hotList[2].bid)}>{hotList[2].title}</div>
                                <div onClick={() => this.toDelite(hotList[3].bid)} style={{ marginTop: 10 }}>{hotList[3].title}</div>
                            </div>
                            <div></div>
                        </div>


                    </Grid>

                }
            </Grid>
        )

    }
    _onClickNews = (data) => {
        let os = 0;
        if (AppData.os != 0 && AppData.os != '') {
            os = AppData.os
        }
        ToName(this.props, `/newsdetail/${data.id}/${os}`)
    }
    //今日快讯
    _renderHotNew = (rowData) => {
        const { classes } = this.props;
        let datas = rowData.list

        return (
            <Grid container className={classes.listItem} style={{ borderRadius: 10, marginTop: 10 }}>

                {
                    datas.length > 0 && this._renderCircleHeader('今日快讯', 2, 'New')
                }

                <Grid container direction='column' justifyContent='center' alignItems='center' className={classes.container} style={{ borderRadius: 10 }}>
                    {


                        datas.map((data, i) =>
                            <Grid container direction='column' key={i}>
                                <Grid container style={{ width: '100vm', overflow: 'hidden' }} >
                                    <div className={classes.itemView} onClick={() => this._onClickNews(data)} >

                                        <div className={classes.itemColumn} >
                                            <div className={classes.title}>{data.title}</div>
                                            <div className={classes.time}>{data.createdDate}</div>
                                        </div>
                                        <img style={{ borderRadius: 10, height: 70, width: 95, objectFit: 'cover' }} src={data.imgUrl} />
                                    </div>
                                </Grid>
                                {i !== datas.length - 1 &&
                                    <Divider style={{ marginLeft: 10, marginRight: 10 }} />
                                }
                            </Grid>
                        )
                    }
                </Grid>
            </Grid>
        )

    }

    _renderItem = (rowData, index) => {
        const { classes } = this.props;

        //今日推荐和比赛集锦


        if (rowData && rowData.list && rowData.list.length > 0) {

            if (rowData.type == 3) {
                //这里是比赛集锦
                let datas = AppUtils.processList(rowData.list, 2);

                return (
                    <Grid container className={classes.listItem} style={{ borderRadius: 10, marginTop: 10 }}>

                        {
                            rowData.list.length > 0 && this._renderSectionHeader(rowData)
                        }

                        <Grid container direction='row' justifyContent='center' alignItems='center' className={classes.container} style={{ borderRadius: 10 }}>
                            {
                                datas.length > 0 && <Swiper {...this.params} style={{ zIndex: 0 }}>
                                    {
                                        datas.map((item, i) => this._renderType3(item, i))
                                    }
                                </Swiper>
                            }
                        </Grid>


                    </Grid>

                )
            } else if (rowData.type == 4) {
                return this._renderHotCircle(rowData)

            } else if (rowData.type == 5) {
                return this._renderHotNew(rowData)
            }
            else {
                return (
                    <Grid style={{ borderRadius: 10, overflow: 'hidden' }}>
                        {
                            rowData.list.map((item, i) => {
                                if (rowData.list[i].list.length == 0) {
                                    return <div key={i}></div>
                                }
                                let datas = AppUtils.processList(rowData.list[i].list, 2);
                                return (
                                    <Grid key={i} container className={classes.listItem} style={{ marginBottom: 0 }}>

                                        {
                                            rowData.list[i].list.length > 0 && this._renderSectionHeader(rowData.list[i])
                                        }
                                        {datas.map((item, i) => (
                                            <Grid key={i} container direction='row' className={classes.doubleItemRow}  >
                                                <Grid container className={classes.doubleItemCon1}>
                                                    {
                                                        item[0] && <PreviewDoubleItem hot={i == 0} data={item[0]} isRocomm={i < 2 && item[0].room_id && item[0].room_id > 0} />
                                                    }
                                                </Grid>
                                                <Grid container className={classes.doubleItemCon2}>
                                                    {
                                                        item[1] && <PreviewDoubleItem data={item[1]} isRocomm={i < 2 && item[1].room_id && item[1].room_id > 0} />
                                                    }
                                                </Grid>
                                            </Grid>
                                        ))
                                        }
                                    </Grid>
                                )
                            })
                        }

                    </Grid>
                )
            }


        } else {
            return <></>
        }


    }

    // _renderFooter = () => {
    //     const { classes } = this.props;
    //     return (<Grid container justifyContent='center' alignItems='center' className={classes.footer}></Grid>)
    // }
    toImage = () => {
        this.props.history.push({ pathname: '/teamInfo' });
    }
    _renderFooter = () => {
        const { classes } = this.props;
        return (<Grid container justifyContent='center' alignItems='center' className={classes.footer}>

            {
                this.state.h5Foot &&
                <div id='contentdiv' dangerouslySetInnerHTML={{ __html: this.state.h5Foot }} className={classes.fontContent}></div>

            }
        </Grid>)
    }

    _renderSectionHeader = (sectionData) => {
        return (
            <MSectionHeader title={sectionData.recomm_title} subtitle='更多' chevron={true} onClick={() => this._onClickMore(sectionData)} />
        )
    }

    toCircleMore = (index) => {
        IMEventEmitter.emit('changeHomeTabIndex', index)
    }

    _renderCircleHeader = (title, index, subTitle) => {
        const { classes } = this.props;
        return (
            // <MSectionHeader title={title} subtitle='更多' chevron={true} onClick={() => this.toCircleMore(index)} />
            <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ width: '100vw' }}  >
                <Grid container direction='row' alignItems='center' style={{ width: '70%' }}>

                    <Typography className={classes.dtitle} style={{

                        color: '#0D0D0D'
                    }}>{title}</Typography>

                    <Grid style={{
                        backgroundColor: '#EC2835',
                        color: '#fff',
                        borderRadius: 50,
                        paddingLeft: 5,
                        paddingRight: 5,
                        textAlign: 'center',
                        fontSize: 10,
                        height: '15px',
                        lineHeight: '15px',
                        marginTop: 4,
                        marginLeft: 10

                    }}>
                        {subTitle}
                    </Grid>
                </Grid>
                <ButtonBase disableRipple onClick={() => this.toCircleMore(index)} className={classes.dleftButton}>
                    <Grid container direction='row' alignItems='center' justifyContent='center' style={{ height: 20, flex: 1, width: 53 }}  >
                        <Typography className={classes.dsubtitle}>更多</Typography>
                        <ChevronRightOutlinedIcon className={classes.dchevron} />
                    </Grid>
                </ButtonBase>
            </Grid>
        )
    }


    _renderHeader = () => {
        return (
            <Grid style={{ flexDirection: 'column', width: '100vw', marginBottom: 10 }} >
                <SlideBanner history={this.props.history} />
                {/* <AnchorRank /> */}
                <Livelist title={this.state.topTtitle} />
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { data, isRefreshing } = this.state;
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });



        if (data) {
            // console.log('datas===>', data);
            return <div className={classes.list} style={{ overflowY: 'auto', }} >

                <ListView
                    initialListSize={data.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100vw', height: '100%', maxWidth: '100%', padding: 0, backgroundColor: 'transparent', }}
                    contentContainerStyle={{ width: '100%', padding: 0 }}
                    dataSource={ds.cloneWithRows(data)}
                    renderRow={this._renderItem}
                    pageSize={PAGE_SIZE}
                    useBodyScroll={false}
                    renderHeader={this._renderHeader}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={10}
                    pullToRefresh={
                        <PullToRefresh
                            refreshing={isRefreshing}
                            onRefresh={this._onRefresh}
                        />
                    }
                    // ref={el => { this._handelRef(el) }}
                    renderFooter={this._renderFooter}
                >
                </ListView>
            </div>
        }
        // return <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        //     <CircularProgress color='secondary' size={20} />  
        // </div>;
        return <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
            < img src={ICON_GIF} style={{ width: 280, height: 280, marginTop: 150, objectFit: 'scale-down' }}></img>
            {/* <Typography style={{ fontSize: 12, color: '#878787', }} >赛事正在加载中...</Typography> */}
        </div>

    }

}

export default withRouter(withStyles((theme) => ({
    fontContent: {
        width: '94vw',
        padding: theme.spacing(2, 1, 2, 1),
    },
    dline: {
        width: 3,
        height: 15,
        borderRadius: 1.5,
        margin: theme.spacing(2, 0, 2, 1),
    },
    dtitle: {
        margin: theme.spacing(2, 0, 2, 1),
        height: theme.typography.pxToRem(18),
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.palette.common.default,
    },
    dsubtitle: {
        height: theme.typography.pxToRem(18),
        color: '#898989',
        fontSize: 12,
    },
    dchevron: {
        color: '#919191',
        fontSize: 16,
    },

    dleftButton: {
        padding: theme.spacing(0, 0, 0, 0),
        borderRadius: 10,
        height: 20,
        marginRight: theme.spacing(1)
    },
    indexRoot: {
        width: '100vw',
        height: 170,
        backgroundColor: '#FFF',
    },
    hotView: {
        backgroundColor: 'rgba(0,0,0,0.3)',
        height: 18,
        width: 52,
        borderRadius: 9,
        position: 'absolute',
        top: 4,
        right: 4,
        flex: 1,
    },
    root: {

        width: 110,

    },
    itemColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '70%'

    },
    itemView: {
        width: '100%',

        backgroundColor: '#fff',
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 10
    },

    container: {
        width: '100vw',
        backgroundSize: '100% 100%',
        margin: theme.spacing(0, 0, 1, 0),
    },
    list: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        height: '100%',
    },
    doubleBottom: {
        width: '100%',
        margin: theme.spacing(0, 0, 3, 0),
    },
    doubleItemRow: {
        width: '100%',
        margin: theme.spacing(0, 0, 0, 0),
    },
    doubleItemCon1: {
        width: '50%',
        padding: theme.spacing(0, 0.5, 0, 1),
    },
    doubleItemCon2: {
        width: '50%',
        padding: theme.spacing(0, 1, 0, 0.5),
    },
    subtitle: {
        width: '100%',
        padding: theme.spacing(0, 1),
        margin: theme.spacing(2, 0, 2, 0),
        height: theme.typography.pxToRem(18),
    },
    subtitleFlag: {
        width: 5,
        height: '90%',
        borderRadius: 3,
        backgroundColor: theme.palette.secondary.main,
        margin: theme.spacing(0, 1, 0, 0),
    },
    bannerImg: {
        width: "calc(100vw - 16px)",
        height: '100%',
        objectFit: 'scale-down',

        borderRadius: 10,
    },
    footer: {
        width: '100%',
        marginBottom: 180,
    },
    changeBtn: {
        backgroundColor: '#FFE0E6',
        width: '45vw',
        height: 36,
        borderRadius: 18,
        color: "#F82A5C",
        fontSize: 12,
    },
    title: {
        color: '#0D0D0D',
        fontSize: 14,
    },
    time: {
        color: '#919191',
        fontSize: 10,
        marginTop: 10,
    },
    listItem: {
        backgroundColor: 'white',
    }
}))(HomeList));